export default "__VITE_ASSET__ff707aba__"